import { Textfit } from "react-textfit";
import "../NewsletterPicker/NewsletterPickerRow.scss";
import { OBMarketingAnswerModel } from "@models/Models";
import { FC } from "react";

interface MarketingAnswerProps {
	marketingAnswer: OBMarketingAnswerModel;
	isSelected: boolean;
	onSelect: (marketingAnswer: OBMarketingAnswerModel) => void;
}

const MarketingRow: FC<MarketingAnswerProps> = ({ marketingAnswer, isSelected, onSelect }) => {
	return (
		<div key={marketingAnswer.key}>
			<div className={`flex p-[30px] flex-row w-full justify-between items-center gap-2 cursor-pointer select-newsletter-row transition ease-in-out ${isSelected ? "selected-sender" : "hover:bg-white/20"}`} onClick={() => onSelect(marketingAnswer)}>
				<div className="flex flex-row items-center text-left gap-3">
					<div className="text-white font-medium text-xl font-primary">
						{marketingAnswer.emoji}
					</div>
					<div className="text-white font-medium text-lg font-primary">
						{marketingAnswer.title}
					</div>
				</div>
			</div>
		</div>
	);
};

export default MarketingRow;
